(() => {
if (window.pjv2StorefrontLoaded) return;
window.pjv2StorefrontLoaded = true;
let generation=0,timer,refreshController,busy=false,fullRefresh=true,cart={items:[]};
const initialUsed = new WeakSet();
let refreshing=0,insertedPending=false,insertedTimer,expiryTimer,expiresAt=Infinity;
let appliedDiscount=null, discountApplication=null;
const roots = () => [...document.querySelectorAll('[data-pjv2]')];
const configuration = () => {
  const element = document.getElementById('pjv2-config');
  if (!element) return null;
  try { return JSON.parse(element.textContent); } catch { return null; }
};
const text = (key, replacements = {}) => {
  let result = configuration()?.text?.[key] || key;
  for (const [name,value] of Object.entries(replacements)) result = result.replaceAll('['+name+']', String(value));
  return result;
};
const money = cents => display.compactMoney(cents,document.documentElement.lang,configuration()?.currency);
const route = suffix => (configuration()?.root || '/').replace(/\/$/,'') + '/' + suffix;
const countInCart = id => cart.items.filter(item => String(item.variant_id) === String(id)).reduce((sum,item) => sum + item.quantity,0);
const quantity = root => Number(root.querySelector('[data-pjv2-quantity]')?.value || root.dataset.min || 1);
const capacity = root => root.dataset.available !== 'true' ? 0 : root.dataset.tracked === 'true' ? Math.max(0,Number(root.dataset.stock) - countInCart(root.dataset.variant)) : Infinity;
const canAdd = (root, qty) => !root.dataset.variantPending && Number.isSafeInteger(qty) && qty >= Number(root.dataset.min || 1) && qty % Number(root.dataset.step || 1) === 0
  && qty <= capacity(root) && (!root.dataset.max || qty + countInCart(root.dataset.variant) <= Number(root.dataset.max));
const message = (root,value) => { const el=root.querySelector('.pjv2-message');if(el)el.textContent=value; };
let display;
function cancel(){generation++;refreshController?.abort();clearTimeout(timer);}
async function json(url,options={}) {
  const signal=AbortSignal.timeout(12000);
  const response=await fetch(url,{...options,headers:{Accept:'application/json',...options.headers},cache:'no-store',signal:options.signal?AbortSignal.any([options.signal,signal]):signal});
  const data=await response.json();
  if(!response.ok || data.status >= 400) throw new Error(data.description || text('error'));
  return data;
}
function buttons(root,ready=true) {
  display?.purchaseButtons(root,{busy,ready,remaining:capacity(root),inCart:countInCart(root.dataset.variant),quantity:quantity(root),canAdd:qty=>canAdd(root,qty),text});
}
function paint(root,quote) {
  delete root.dataset.checking;
  display.imageBadge(root,quote,configuration()?.badges,money);
  if(!quote.available) { message(root,text('sold_out'));buttons(root,false);return; }
  display.paintPrice(root,quote,text,money);
  if(root.dataset.mode==='multi-buy')display.renderOffers(root,quote,text,money);
  root.dataset.ready='true';
  message(root,'');
  buttons(root);
}
async function refresh(onlyQuantity=false,allowInitial=false) {
  const config=configuration();
  if(!config) return;
  const version=++generation;
  refreshController?.abort();
  const controller=refreshController=new AbortController();
  let currentRoots=roots().filter(root=>!onlyQuantity || root.dataset.ready!=='true');
  if(!currentRoots.length)return;
  refreshing++;
  currentRoots.forEach(root=>{delete root.dataset.ready;root.dataset.checking='true';buttons(root,false);});
  const failed=root=>{delete root.dataset.checking;display?.imageBadge(root,null,config.badges,money);message(root,text('error'));buttons(root,false);};
  try {
    const [displayModule,pricingModule,nextCart,discountModule]=await Promise.all([
      display || import(new URL('pjv2-preview-display.js',scriptUrl).href),
      import(new URL('pjv2-preview-quotes.js',scriptUrl).href),
      onlyQuantity && !allowInitial && cart.currency ? cart : json(route('cart.js'),{signal:controller.signal}),
      import(new URL('pjv2-preview-discounts.js',scriptUrl).href)
    ]);
    if(version!==generation)return;
    display=displayModule;cart=nextCart;
    const code=discountModule.discountCode({href:location.href,cookie:document.cookie,cart});
    currentRoots=currentRoots.filter(root=>{
      const quote=allowInitial && !code && !initialUsed.has(root) ? pricingModule.initialQuote(root,config,cart,quantity(root)) : null;
      initialUsed.add(root);
      if(!quote)return true;
      paint(root,quote);
      if(quote.expires<expiresAt){expiresAt=quote.expires;clearTimeout(expiryTimer);expiryTimer=setTimeout(()=>{expiresAt=Infinity;schedule();},Math.max(0,quote.expires*1000-Date.now()));}
      return false;
    });
    const market=pricingModule.pricingMarket(config,cart,window.Shopify?.currency);
    const cartLines=cart.items.map(item=>({variant_id:'gid://shopify/ProductVariant/'+item.variant_id,quantity:item.quantity}));
    await pricingModule.refreshPrices({roots:currentRoots,quantity,current:()=>version===generation,failed,
      load:async queries=>{
        if(!market)return {active:false};
        const data=await json(config.proxy.replace(/\/$/,'')+'/prices',{method:'POST',signal:controller.signal,headers:{'Content-Type':'application/json'},body:JSON.stringify({...market,...(code?{discount_code:code}:{}),queries,cart:cartLines})});
        if(data.currency!==market.currency)throw Error('Invalid price currency');
        if(code && data.code_status==='verified' && appliedDiscount!==code) {
          if(!discountApplication)discountApplication=discountModule.applyDiscount({code,cart,json,route}).then(next=>{cart=next;appliedDiscount=code;}).finally(()=>{discountApplication=null;});
          await discountApplication;
        }
        return data;
      },
      apply:(root,quote,qty)=>paint(root,quote || display.nativeQuote(root,qty))});
  } catch {
    if(version!==generation)return;
    currentRoots.forEach(failed);
  } finally {
    refreshing--;
    if(insertedPending && !refreshing && !busy)inserted();
  }
}
function inserted() {
  insertedPending=true;
  if(refreshing || busy)return;
  clearTimeout(insertedTimer);
  insertedTimer=setTimeout(()=>{insertedPending=false;return refresh(true,true);},0);
}
function schedule(root,allowInitial=false) {
  if(root?.dataset){delete root.dataset.ready;root.dataset.checking='true';buttons(root,false);}else fullRefresh=true;
  cancel();
  timer=setTimeout(()=>{const all=fullRefresh;fullRefresh=false;return refresh(!all,allowInitial);},60);
}
const scriptUrl=document.currentScript?.src;
async function add(root,button) {
  if(busy || root.dataset.variantPending || button.disabled)return;
  busy=true;cancel();
  const variant=root.dataset.variant,qty=Number(button.dataset.quantity || quantity(root));
  button.dataset.adding='true';roots().forEach(item=>buttons(item,false));
  try {
    const module=await import(new URL('pjv2-preview-cart.js',scriptUrl).href);
    await module.addToCart({root,button,variant,qty,json,route,text,canAdd,capacity,message,config:configuration(),currency:window.Shopify?.currency,setCart:value=>{cart=value;}});
  } catch {message(root,text('error'));}
  finally {
    busy=false;delete button.dataset.adding;
    cart=await json(route('cart.js')).catch(()=>cart);
    roots().forEach(item=>buttons(item,item.dataset.ready==='true'));
    schedule();
  }
}
document.addEventListener('click',event=>{
  const step=event.target.closest('[data-pjv2-step]');
  if(step && !step.disabled && display) {
    const root=step.closest('[data-pjv2]'),input=root?.querySelector('[data-pjv2-quantity]');
    if(!input)return;
    const next=display.steppedQuantity(root,Number(input.value),Number(step.dataset.pjv2Step),capacity(root),countInCart(root.dataset.variant));
    if(next!==null){input.value=String(next);schedule(root);}
    return;
  }
  const button=event.target.closest('[data-pjv2-add]'),root=button?.closest('[data-pjv2]');
  if(root){event.preventDefault();add(root,button);}
});
document.addEventListener('input',event=>{
  if(event.target.matches('[data-pjv2-quantity]'))schedule(event.target.closest('[data-pjv2]'));
});
document.addEventListener('change',async event=>{
  if(event.target.matches('[data-pjv2-variant]')) {
    if(busy)return;
    const root=event.target.closest('[data-pjv2]');
    root.closest('product-info')?.querySelectorAll('[data-pjv2]').forEach(item=>{item.dataset.variantPending='true';buttons(item,false);});
    root.closest('product-info')?.productForm?.toggleSubmitButton(true);
    cancel();
    try{
      await (await import(new URL('pjv2-preview-variants.js',scriptUrl).href)).selectVariant(event.target,{busy:()=>busy,done:schedule,text});
    }catch{message(root,text('error'));}return;
  }
  if(event.target.matches('product-info input[name="id"]')) {
    const info=event.target.closest('product-info');
    info?.querySelectorAll('[data-pjv2]').forEach(root=>{delete root.dataset.ready;root.dataset.checking='true';display?.imageBadge(root,null,configuration()?.badges,money);buttons(root,false);message(root,text('checking'));});
  }
});
document.addEventListener('shopify:section:load',schedule);
document.addEventListener('pjv2:cart-updated',schedule);
if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate,schedule);
  subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
    for(const root of roots()) {
      if(root.dataset.section!==data.sectionId)continue;
      const replacement=data.html.getElementById(root.id);
      if(replacement){display?.imageBadge(root,null,configuration()?.badges,money);root.replaceWith(replacement.cloneNode(true));}
    }
    schedule();
  });
}
new MutationObserver(records=>{
  if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches('[data-pjv2]') || node.querySelector('[data-pjv2]')))))inserted();
}).observe(document.body,{childList:true,subtree:true});
window.addEventListener('pageshow',event=>{if(event.persisted)schedule();});
  schedule(null,true);
})();
